import { SET_UNREAD_MESSAGES } from "../acions/types";

const initialState = { hasNotification: false };

export default function unreadMessages(state = initialState, action: any) {
  const { type, payload } = action;

  switch (type) {
    case SET_UNREAD_MESSAGES:
      return { hasNotification: payload };
    default:
      return state;
  }
}
